import { COLORS, RADIUS, fontFamilyFor } from "../../theme";

const headingFont = (isArabic) =>
  isArabic ? fontFamilyFor("ar") : "'Playfair Display', serif";

export const Style = {
  page: {
    background: COLORS.dark,
    color: "#fff",
    minHeight: "60vh",
  },
  hero: {
    padding: { xs: "3rem 1.5rem 2rem", md: "6rem 3rem 3rem" },
    textAlign: "center",
  },
  heroTitle: (isArabic) => ({
    fontFamily: headingFont(isArabic),
    fontSize: { xs: "2.6rem", md: "4rem" },
    fontWeight: 700,
    mb: "1rem",
    background: `linear-gradient(135deg, #fff 0%, ${COLORS.peach} 100%)`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  }),
  subtitle: {
    fontSize: { xs: "1.05rem", md: "1.3rem" },
    color: "rgba(255,255,255,0.7)",
    maxWidth: "700px",
    margin: "0 auto",
  },
  loaderWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6rem 1.5rem",
  },
  errorWrap: {
    textAlign: "center",
    padding: "4rem 1.5rem 6rem",
  },
  errorText: {
    color: "rgba(255,255,255,0.7)",
    fontSize: "1.1rem",
    mb: "1.5rem",
  },
  backButton: {
    display: "inline-block",
    padding: "0.9rem 2.2rem",
    background: COLORS.peach,
    color: COLORS.dark,
    borderRadius: RADIUS.pill,
    fontWeight: 700,
    fontSize: "1rem",
    cursor: "pointer",
    border: "none",
    "&:hover": { background: COLORS.gold },
  },
  grid: (isArabic) => ({
    maxWidth: "1200px",
    margin: "0 auto",
    padding: { xs: "1rem 1.5rem 5rem", md: "1rem 3rem 6rem" },
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "2rem",
    direction: isArabic ? "rtl" : "ltr",
  }),
  card: {
    background: COLORS.gray,
    borderRadius: RADIUS.card,
    border: "1px solid rgba(255,255,255,0.05)",
    padding: "2rem",
    textAlign: "center",
  },
  photoWrap: {
    width: "120px",
    height: "120px",
    margin: "0 auto 1.2rem",
    borderRadius: "50%",
    overflow: "hidden",
    background: `linear-gradient(135deg, ${COLORS.gold}, ${COLORS.peach})`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  photoImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  photoFallback: {
    fontSize: "3rem",
    color: COLORS.dark,
  },
  name: (isArabic) => ({
    fontFamily: headingFont(isArabic),
    fontSize: "1.3rem",
    fontWeight: 600,
    color: "#fff",
    margin: "0 0 0.3rem",
  }),
  ethnicity: {
    color: COLORS.peach,
    fontSize: "0.9rem",
    margin: "0 0 0.9rem",
  },
  bio: {
    color: "rgba(255,255,255,0.72)",
    fontSize: "0.95rem",
    lineHeight: 1.6,
    margin: "0 0 1rem",
  },
  influence: {
    color: "rgba(255,255,255,0.5)",
    fontSize: "0.85rem",
    margin: "0 0 1rem",
  },
  socials: {
    display: "flex",
    justifyContent: "center",
    gap: "0.9rem",
  },
  socialLink: {
    color: "rgba(255,255,255,0.7)",
    fontSize: "1.3rem",
    display: "flex",
    "&:hover": { color: COLORS.peach },
  },
  emptyWrap: {
    textAlign: "center",
    padding: "2rem 1.5rem 6rem",
  },
  emptyText: {
    color: "rgba(255,255,255,0.6)",
    fontSize: "1.05rem",
  },
};
